import Link from 'next/link';
import Button, { ButtonStyle } from '../../../components/button/Button';
import CardNewsEventsComponent from '../../../components/cards/card-news-events/CardNewsEvents';
import SectionHeaderCms from '../../../components/section-header-cms/SectionHeaderCms';
import { NewsEvents } from '../../../models/auto-generated-strapi-types/types/components/NewsEvents';
import {
  ButtonWrapper,
  CardsWrapper,
  InnerWrapper,
  OuterWrapper,
} from './NewsEvents.style';
import { getEvents, getNews } from '../../../utils/api';
import { normalizeAttributesNewsEventsSliders } from '../../../utils/event';
import { compareDesc, parse } from 'date-fns';
import {
  GlobalResponse,
  SingleStrapiImage,
  Slug,
} from '../../../models/domain/interfaces';

interface BaseCardProps {
  url?: any;
  title: string;
  description: string;
  text: string;
  category: string;
  thumbnail: SingleStrapiImage;
  mobileThumbnail?: SingleStrapiImage;
  coverImage: SingleStrapiImage;
  mobileCoverImage?: SingleStrapiImage;
  overlayColor: string;
  coverTextColor?: string;
  date: string;
  startDate?: string;
  endDate?: string;
  button?: {
    url: string;
    text: string;
    type: string;
    newTab: boolean;
  };
}

export interface NewsEventSectionProps extends NewsEvents {
  cards: {
    id: number;
    attributes: BaseCardProps;
  }[];
}

const NewsEventSection: React.FC<any> = ({
  data,
  isPrerenderRequest,
}: {
  data: NewsEventSectionProps;
  isPrerenderRequest: boolean;
}) => {
  return (
    <OuterWrapper color={data?.backgroundColor}>
      <InnerWrapper>
        {data?.sectionHeader && (
          <SectionHeaderCms
            id={data?.id}
            description={data?.sectionHeader?.description}
            personalization={data?.sectionHeader?.personalization}
            mainTitle={data?.sectionHeader?.mainTitle}
            title={data?.sectionHeader?.title}
            backgroundColor={data?.sectionHeader?.backgroundColor}
            topIcon={data?.sectionHeader?.topIcon}
            isPrerenderRequest={isPrerenderRequest}
          />
        )}
        {data?.cards?.length && (
          <CardsWrapper>
            {data?.cards?.map((card) => {
              return (
                <CardNewsEventsComponent
                  data={{
                    attributes: {
                      ...card?.attributes,
                      isPrerenderRequest: isPrerenderRequest,
                    },
                    id: card?.id,
                  }}
                  personalization={data?.personalization}
                  cols={data?.columnsNumber}
                />
              );
            })}
          </CardsWrapper>
        )}
        {data?.button && data?.button.url && data?.button.text && (
          <ButtonWrapper>
            <Link href={data?.button?.url} passHref>
              <Button
                text={data?.button?.text}
                styleBtn={ButtonStyle?.primary}
                asA={true}
              />
            </Link>
          </ButtonWrapper>
        )}
      </InnerWrapper>
    </OuterWrapper>
  );
};

export default NewsEventSection;

export const getServerSideProps = async (
  section: any,
  translations: any,
  slugAnalyzed: Slug,
  globalLocale: GlobalResponse
) => {
  const news = (
    await getNews({
      locale: slugAnalyzed?.locale,
      pageSize: 6,
      sort: ['date:desc'],
      datesFormat: translations?.date?.sliderNewsEvents?.format,
    })
  ).data;
  const events = await getEvents({
    locale: slugAnalyzed?.locale,
    pageSize: 6,
    sort: ['publishedAt:desc'],
    datesFormat: translations?.date?.sliderNewsEvents?.format,
  });
  const sorted = [
    ...(normalizeAttributesNewsEventsSliders(
      news,
      'news',
      translations,
      globalLocale?.attributes?.newsAndEventsMerged || false,
      slugAnalyzed.locale
    ) || []),
    ...(normalizeAttributesNewsEventsSliders(
      events,
      'events',
      translations,
      globalLocale?.attributes?.newsAndEventsMerged || false,
      slugAnalyzed.locale
    ) || []),
  ].sort((a, b) => {
    const lhs = parse(
      a?.attributes?.date,
      translations?.date?.sliderNewsEvents?.format,
      new Date()
    );
    const rhs = parse(
      b?.attributes?.date,
      translations?.date?.sliderNewsEvents?.format,
      new Date()
    );
    return compareDesc(lhs, rhs);
  });

  section.cards = sorted;
};
